import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20soft%20amber%20and%20cream%20tones%2C%20modern%20minimalist%20digital%20art%2C%20smooth%20curves%2C%20clean%20aesthetic%2C%20no%20text%2C%20soft%20atmospheric%20lighting%2C%20elegant%20professional%20design%20with%20subtle%20warm%20gradients&width=1800&height=1200&seq=hero-bg-91web&orientation=landscape"
          alt="91网页版入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-background-50">官方直达通道 · 安全可靠</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-5">
            91网页版入口
            <span className="block text-xl md:text-2xl lg:text-3xl font-sans font-light mt-3 text-background-200">
              官方直达通道，无需下载，即开即用
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto mb-8 leading-relaxed">
            91网页版入口是您访问91平台最便捷的方式，打开浏览器即可直接进入。
            提供最新入口地址、访问教程及常见问题解答，确保您随时顺畅访问。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/access-tutorial"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-line mr-2"></i>
              查看访问教程
            </Link>
            <Link
              to="/category/faq-solutions"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line mr-2"></i>
              常见问题解答
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8 text-background-200/70 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>无需下载</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>跨平台使用</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>安全加密</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}